import {FILTRAR_RESUMO_VEICULO} from '../types';


export default function filtrarResumoVeiculo(resumoVeiculo, texto) {
  return {
    type: FILTRAR_RESUMO_VEICULO,
    payload: { resumoVeiculo, texto }
  };
}
